import { handleResponse, handleBlobResponse } from "utils/utils";
import { authService } from "services";

export const ubicationsService = {
	getAll,
	getSelectable,
	getById,
	add,
	update,
	remove,
	downloadImportTemplate,
	prepareImport,
	runImport,
};

// get all ubications
function getAll(options) {
	const opts = options && typeof options === "object" ? options : {};
	const { q, enabled } = opts;

	const requestOptions = {
		method: 'GET',
		headers: {
			'Authorization': `Bearer ${authService.token.access_token}`
		},
	};

	let query = '?sort=+name&page_size=10000';

	if (q !== undefined && q !== null && String(q).length > 0)
		query += "&q=" + encodeURIComponent(q);

	if (enabled)
		query += "&enabled=" + enabled;

	return fetch(`${global.BASE_API}ubications${query}`, requestOptions).then(handleResponse);
}

// gets selectable ubications
function getSelectable(options) {
	const requestOptions = {
		method: 'GET',
		headers: {
			'Authorization': `Bearer ${authService.token.access_token}`
		},
	};

	let query = '?sort=+name&variant=select&enabled=true&page_size=10000';

	if (options) {
		const { q } = options;

		if (q !== undefined && q !== null && String(q).length > 0)
			query += "&q=" + encodeURIComponent(q);
	}

	return fetch(`${global.BASE_API}ubications${query}`, requestOptions).then(handleResponse);
}

// get one ubication by id
function getById(id) {
	const requestOptions = {
		method: 'GET',
		headers: {
			'Authorization': `Bearer ${authService.token.access_token}`
		},
	};

	return fetch(`${global.BASE_API}ubications/${id}`, requestOptions).then(handleResponse);
}

// add new ubication
function add(func) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${authService.token.access_token}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(func)
	};

	return fetch(`${global.BASE_API}ubications/`, requestOptions).then(handleResponse);
}

// update ubication
function update(func) {
	const requestOptions = {
		method: 'PUT',
		headers: {
			'Authorization': `Bearer ${authService.token.access_token}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(func)
	};

	return fetch(`${global.BASE_API}ubications/${func.id}`, requestOptions).then(handleResponse);
}

// remove ubication
function remove(id) {
	const requestOptions = {
		method: 'DELETE',
		headers: {
			'Authorization': `Bearer ${authService.token.access_token}`
		},
	};

	return fetch(`${global.BASE_API}ubications/${id}`, requestOptions).then(handleResponse);
}



/**********************************************************************
 ****** IMPORT UBICATIONS
 ***********************************************************************/

function downloadImportTemplate() {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
	};

	return fetch(
		`${global.BASE_API}ubications/imports/template`,
		requestOptions
	).then(handleBlobResponse);
}

function prepareImport(formData) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
		body: formData,
	};

	return fetch(`${global.BASE_API}ubications/imports`, requestOptions).then(
		handleResponse
	);
}

function runImport(token) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	return fetch(
		`${global.BASE_API}ubications/imports/${token}`,
		requestOptions
	).then(handleResponse);
}